import React, { type ReactNode } from "react"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import clsx from "clsx"
import BgImg from "./images/BgImg"
import PercentLeftImg from "./images/PercentLeftImg"
import PercentRightImg from "./images/PercentRightImg"
import CreditCardImg from "./images/CreditCardImg"
import HalvaImg from "./images/HalvaImg"
import ChristmasTreeImg from "./images/ChristmasTreeImg"
import DnejImg from "./images/180Dnej"

import * as styles from "./bottomCta.module.scss"
import { DLClickEventExtended } from "../../helpers/WatcherDL/DLEvents"
import getTextFromNode from "../../helpers/getTextFromNode"
import scrollToPersonalForm from "../../helpers/scrollToPersonalForm"
import IvanCardImg from "./images/IvanCard"
import PkwCardImg from "./images/PkwCardImg"
import PkwRubImg from "./images/PkwRubImg"

const DEFAULT_TEXT = (
  <>
    Оформите Халву и получите <br /> <b> месяц подписки в подарок</b>
  </>
)

interface BottomCtaProps {
  text?: ReactNode
  buttonText?: string
  orderNum?: string
  variantStyles?: "creditCardMedia" | "newYearMedia" | "creditCard180Dnej" | "pkwCreditCards"
}

export const BottomCta = ({
  text = DEFAULT_TEXT,
  buttonText = "Оформить карту",
  orderNum,
  variantStyles,
}: BottomCtaProps) => {
  const handleClick = () => {
    DLClickEventExtended({
      name: buttonText,
      eventAction: getTextFromNode(text).slice(0, 30),
      placement: "promo",
    })
    scrollToPersonalForm()
  }

  const renderImage = () => {
    switch (variantStyles) {
      case "creditCardMedia":
        return (
          <>
            <CreditCardImg alt="credit card" className={styles.creditCardImg} />
          </>
        )

      case "pkwCreditCards":
        return (
          <>
            <PkwCardImg alt="credit card" className={styles.pkwCardImg} />
            <PkwRubImg alt="rub" className={styles.pkwRubImg} />
          </>
        )

      case "creditCard180Dnej":
        return (
          <>
            <IvanCardImg alt="example card" className={styles.ivanCardImg} />
            <DnejImg alt="180 days without oercents" className={styles.dnejImg} />
          </>
        )

      case "newYearMedia":
        return (
          <>
            <HalvaImg alt="halva" className={styles.halvaImg} />
            <ChristmasTreeImg alt="christmas tree" className={styles.christmasTreeImg} />
          </>
        )

      default:
        return (
          <>
            <PercentLeftImg alt="percent" className={styles.percentLeftImg} />
            <PercentRightImg alt="percent" className={styles.percentRightImg} />
          </>
        )
    }
  }

  return (
    <section
      id="bottomCta"
      className={clsx(styles.section, variantStyles && styles[variantStyles])}
      data-exclude={orderNum}
    >
      <Container>
        <div className={styles.wrapper}>
          <BgImg alt="background image" className={styles.bgImg} />
          {renderImage()}
          <div className={styles.wrap}>
            <p className={styles.text}>{text}</p>
            <Button className={styles.btn} onClick={handleClick}>
              {buttonText}
            </Button>
          </div>
        </div>
      </Container>
    </section>
  )
}
